import React from 'react';
import TitleServices from '../TitleServices/TitleServices';
import FontsDefault from '../../Assistant/DefaultStyle';
import { DefaultFlex } from '../../Assistant/DefaultStyle';

function RightSideAbout() {
  return (
    <div className='lg:w-4/12 mt-8 md-full w-full justify-center flex-col my-auto '>
      <TitleServices
        showBtn={false}
        title='عن GE Step'
        description='شركة تسويق إلكتروني تعمل في مجال تقديم الخدمات التسويقية وتقديم حلول مبتكرة لنمو العلامة التجارية ومواكبة التطور في العالم الإلكتروني .'
        secondDescription='لدى GE Step فريق من النتخصصين والمبدعين في مجالاتهم .'
      />

      <div className={`mt-10 ${DefaultFlex} mx-auto`}>
        <div className={`${FontsDefault.styleAboutContent}`}>
          <h1 className={`${FontsDefault.fontSizeAbout}`}>+ 25</h1>
          <h1 className={`${FontsDefault.text2xl} text-gray700 mt-3`}>عملاء سعداء</h1>
        </div>
        <div className={`${FontsDefault.styleAboutContent}`}>
          <h1 className={`${FontsDefault.fontSizeAbout}`}>+ 35</h1>
          <h1 className={`${FontsDefault.text2xl} text-gray700 mt-3`}>مشاريع تم تسليمها</h1>
        </div>
      </div>
    </div>
  );
}

export default RightSideAbout;
